export default __webpack_public_path__ + "static/media/avatar.ba1b024d.jpg";